import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AttendeeCard from "./AttendeeCard";
import { filterAttendees } from "@utils/attendeeHelpers";

const AttendeeList = ({
  attendees,
  activityType,
  options,
  activeFilter,
  activity,
}) => {
  const filteredAttendees = filterAttendees(
    attendees,
    activeFilter,
    activityType,
    options,
  );

  if (filteredAttendees.length === 0) {
    return (
      <Flex
        justify="center"
        align="center"
        p={4}
        color="gray.500"
        fontSize="14px"
      >
        <Text>No attendees match the selected filter</Text>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap={1.5}>
      {filteredAttendees.map((attendee) => (
        <AttendeeCard
          key={attendee.user.userId || attendee._id}
          attendee={attendee}
          activityType={activityType}
          options={options}
          activity={activity}
        />
      ))}
    </Flex>
  );
};

export default AttendeeList;
